import * as React from 'react';
import { Heading, Text, Box } from 'wix-style-react';
import { composer } from '../../component-decorators/composer';
export var CounterHolidaySale = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, bigDesign = _a.bigDesign, manageAppsToolTip = _a.manageAppsToolTip;
    var getTimeRemaining = function (time) {
        var total = Date.parse(time) - Date.now();
        var minutes = Math.floor((total / 1000 / 60) % 60);
        var hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        var days = Math.floor(total / (1000 * 60 * 60 * 24));
        return [
            { time: days, text: t('holidaySale.counter.days') },
            { time: hours, text: t('holidaySale.counter.hours') },
            { time: minutes, text: t('holidaySale.counter.minutes') },
        ];
    };
    var styling = bigDesign
        ? {
            marginRight: ['12px', '12px', '6px'],
            padding: ['10px', '9px'],
            height: '35px',
            width: '54px',
            light: true,
            color: '#1c2541',
            skin: 'disabled',
        }
        : manageAppsToolTip
            ? {
                height: '33px',
                width: '42px',
                color: 'D70',
                marginRight: ['6px', '6px', '0px'],
                padding: ['3px', '6px'],
                light: false,
                skin: 'standard',
            }
            : {
                height: '33px',
                width: '42px',
                marginRight: ['6px', '6px', '0px'],
                padding: ['3px', '6px'],
                light: true,
                color: '#1c2541',
                skin: 'disabled',
            };
    var deadlineSale = 'November 21 2021 08:33:00 GMT';
    // tslint:disable-next-line:react-hooks-nesting
    var _b = React.useState(getTimeRemaining(deadlineSale)), countdown = _b[0], setCountdown = _b[1];
    var counters = [];
    // tslint:disable-next-line:react-hooks-nesting
    React.useEffect(function () {
        setInterval(function () {
            setCountdown(getTimeRemaining(deadlineSale));
        }, 60000);
    }, []);
    // tslint:disable-next-line:react-hooks-nesting
    return (React.createElement(Box, null, countdown.map(function (display, i) {
        return (
        // tslint:disable-next-line:jsx-key
        React.createElement(DisplayTime, { number: display.time, marginRight: styling.marginRight[i], text: display.text, height: styling.height, width: styling.width, color: styling.color, padding: styling.padding, light: styling.light, skin: styling.skin, isBigDesign: bigDesign }));
    })));
});
var DisplayTime = function (_a) {
    var number = _a.number, text = _a.text, marginRight = _a.marginRight, height = _a.height, width = _a.width, color = _a.color, padding = _a.padding, light = _a.light, skin = _a.skin, isBigDesign = _a.isBigDesign;
    return (React.createElement(Box, { width: width, height: height, backgroundColor: color, marginRight: marginRight, borderRadius: 8, direction: 'vertical', align: 'center', verticalAlign: 'middle', paddingTop: padding[0], paddingBottom: padding[1] },
        isBigDesign ? (React.createElement(Heading, { appearance: 'H3', light: light }, number)) : (React.createElement(Text, { skin: "standard", light: light, weight: "bold" }, number)),
        React.createElement(Box, { marginTop: '-5px' },
            React.createElement(Text, { skin: skin, marginTop: '-3px', light: light, secondary: !light, weight: "normal", size: "tiny" }, text))));
};
//# sourceMappingURL=counter-holiday-sale.js.map